export default [
  {
    title: 'Home',
    route: 'mlf-dashboard-default',
    icon: 'HomeIcon',
  },
]
